import { UserProfileModel } from "src/app/models/userProfileModel";
import { loadProfile } from "./../../../../core/store/profile/profile.actions";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertService } from "./../../../../shared/services/alert.service";
import {
  signOfferLetterDoc,
  signOfferLetterDocSuccess,
} from "./../../../../core/store/offerletter/offerletter.actions";
import { UserModel } from "src/app/models/userModel";
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { State } from "../../../../core/store";
import { loadOfferLetterDoc } from "src/app/core/store/offerletter/offerletter.actions";
import { Actions, ofType } from "@ngrx/effects";
import { Location } from "@angular/common";
import * as moment from "moment";
import { SignDocComponentBase } from "../../../abstract/signDocBase.component";
import {
  OnBoardingDocumentUserModel,
  OnBoardingDocumentModel,
} from "src/app/models/onBoardingDocumentUserModel";
import {
  signOnboardingDoc,
  loadOnboardingDoc,
  signOnboardingDocSuccess,
  getOnboardingDocsList,
  loadOnboardingDocInfo,
} from "src/app/core/store/onboardingdocs/onboardingdocs.actions";
import { tap } from "rxjs";
import { downloadFile, deepClone, clearArray } from "src/app/helpers/utils";
import {
  loadFormSubmissionDocToSign,
  signFormSubmissionDoc,
  signFormSubmissionDocSuccess,
} from "src/app/core/store/form-builder/form-builder.actions";

@Component({
    selector: "app-form-sign",
    templateUrl: "./form-sign.component.html",
    styleUrls: ["./form-sign.component.scss"],
    standalone: false
})
export class FormSignComponent
  extends SignDocComponentBase
  implements OnInit, AfterViewInit
{
  @Input() formSubmissionID: string;
  @Input() doNotNavigate: boolean;
  loadingSign = false;
  loadingDoc = true;
  user: UserModel;
  @Input() profile: UserProfileModel;
  @Input() isSigningAsHRManager = false;

  constructor(
    private store: Store<State>,
    private actions$: Actions,
    private alert: AlertService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {
    super(store);
  }

  ngOnInit() {
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.signingAsHR) {
        this.isSigningAsHRManager = true;
      }
    });

    this.store.dispatch(loadProfile());
    if (this.formSubmissionID) {
      this.optionalFields.length = 0;
      this.store.dispatch(
        loadFormSubmissionDocToSign({
          formSubmissionID: parseInt(this.formSubmissionID, 10),
        }),
      );
    } else {
      this.route.params.subscribe((params) => {
        if (params.formSubmissionID) {
          this.formSubmissionID = params.formSubmissionID;
          this.optionalFields.length = 0;
          this.store.dispatch(
            loadFormSubmissionDocToSign({
              formSubmissionID: parseInt(this.formSubmissionID, 10),
            }),
          );
        }
      });
    }

    this.subs.push(
      this.store
        .select((s) => s.profileState.profile)
        .subscribe((p) => {
          if (p) {
            this.user = p.user;
          }
        }),
      this.store
        .select((s) => s.formBuilderState.docArrayBuffer)
        .subscribe((docArrayBuffer) => {
          if (docArrayBuffer) {
            if (this.intervalFormattingSignature) {
              clearInterval(this.intervalFormattingSignature);
            }
            clearArray(this.signedFields);
            this.url =
              URL.createObjectURL(
                new Blob([docArrayBuffer], {
                  type: "application/pdf",
                }),
              ) +
              "&avoidcache=" +
              new Date().getTime();

            this.afterPdfViewerInit();
          }
        }),
      this.store
        .select((s) => s.formBuilderState.loadingDoc)
        .subscribe((loadingDoc) => {
          this.loadingDoc = loadingDoc;
        }),
      this.store
        .select((s) => s.formBuilderState.loadingSign)
        .subscribe((loadingSign) => {
          this.loadingSign = loadingSign;
        }),
      this.actions$
        .pipe(
          ofType(signFormSubmissionDocSuccess),
          tap((action) => {
            if (!this.doNotNavigate) {
              this.alert
                .confirm(
                  "Documentation signed succesfully",
                  "Documentation signed succesfully. Do you want to download the signed file now?",
                )
                .subscribe(
                  (answer) => {
                    if (answer) {
                      downloadFile(action.docSigned, "document.pdf");
                    }
                    this.router.navigate(["../../list"], {
                      relativeTo: this.route,
                    });
                  },
                  (error) => {
                    this.router.navigate([`../../list`], {
                      relativeTo: this.route,
                    });
                  },
                );
            }
          }),
        )
        .subscribe(),
    );
  }

  get loggedUserName() {
    return !this.user ? "" : this.user.firstName + " " + this.user.lastName;
  }

  get loggedUserEmail() {
    return !this.user ? "" : this.user.email;
  }

  sign() {
    if (!this.finishSignDisabled) {
      this.store.dispatch(
        signFormSubmissionDoc({
          formSubmissionID: parseInt(this.formSubmissionID, 10),
          signedFields: deepClone(this.signedFields),
        }),
      );
    }
  }
  back() {
    if (!this.finishSignDisabled) {
      this.location.back();
    }
  }
}
